
<div fxLayout="row"  class="p-2" class="search">
    <button  mat-icon-button  color="primary" matTooltip="Affichage en Grille" (click)="changeViewType('grid')">
        <span><mat-icon>grid_view</mat-icon></span>
    </button>
    <button  mat-icon-button  color="primary" matTooltip="Affichage en Liste" (click)="changeViewType('list')">
        <span><mat-icon>format_list_bulleted</mat-icon></span>
    </button>
    <mat-button-toggle-group #controls="matButtonToggleGroup" appearance="legacy">            

        <mat-button-toggle value="search">
            <mat-icon>search</mat-icon>
        </mat-button-toggle>           
    </mat-button-toggle-group>  
    <form class="user-search" [class.show]="controls.value == 'search'">
        <mat-form-field class="user-search-input">
            <input matInput placeholder="Recherche un Vehicule..." (keyup)="applyFilter($event)" name="search">
        </mat-form-field>
    </form>
</div>
<mat-card class="m-2 p-0">
    <div class="table-wrapper" *ngIf="viewType==='list'">

        <table mat-table [dataSource]="dataSource" matSort class="w-100">

            <ng-container matColumnDef="marque">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Marque </th>
                <td mat-cell *matCellDef="let car">{{car.vehicle_mark}} </td>
            </ng-container>
            <ng-container matColumnDef="model">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Modele </th>
                <td mat-cell *matCellDef="let car">{{car.vehicle_model}} </td>
            </ng-container>
            <ng-container matColumnDef="prix">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Prix de location </th>
                <td mat-cell *matCellDef="let car">{{car.vehicle_price_location}} {{appService.getCurrency()}}</td>
            </ng-container>

            <!-- Username Column -->
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date d'enregistrement </th>
                <td mat-cell *matCellDef="let car">{{car.created_at}} </td>
            </ng-container>


            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let car">
                    <mat-form-field appearance="outline" class="p-0 m-0" style="width: 150px">
                        <mat-label> {{car.status}}</mat-label>
                        <mat-select  (selectionChange)="onStatusSelectionChange($event  ,car.id)" [disabled]="car.status.id == 1">
                            <mat-option >---</mat-option>
                            <mat-option *ngFor="let status of statuses" [value]="status">
                                {{status.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </ng-container>

            <ng-container matColumnDef="verification">
                <th mat-header-cell *matHeaderCellDef> Validité </th>
                <td mat-cell  *matCellDef="let cars">
                    <h3>{{cars.verification==1?"Valide":"Refusé"}}</h3>
                    <mat-option  class="user-social"  >
                        <mat-slide-toggle color="primary" [(ngModel)]="cars.verification" (change)="onChange($event, cars.id,cars.status) " > </mat-slide-toggle>
                    </mat-option >
                </td>
            </ng-container>

            <ng-container matColumnDef="priority">
                <th mat-header-cell *matHeaderCellDef> Prioritaire ? </th>
                <td mat-cell *matCellDef="let car">
                    <mat-form-field appearance="outline" class="p-0 m-0" style="width: 100px">
                        <mat-label> {{car.priority?"Oui":"non"}}</mat-label>
                        <mat-select  (selectionChange)="changePrioritycar($event,car.id)">
                            <mat-option [value]="true">Oui</mat-option>
                            <mat-option [value]="false">Non</mat-option>
                           
                        </mat-select>
                    </mat-form-field>
                </td>
            </ng-container>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>

                <td mat-cell *matCellDef="let car">
                    <button mat-icon-button color="primary" (click)="showCar(car.id )" matTooltip="details">
                        <mat-icon>visibility</mat-icon>
                    </button> 
                    <button mat-icon-button color="warn" (click)="remove(car.id )" matTooltip="Remove">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let car; columns: displayedColumns;"></tr>
        </table>
        <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">No data available</p>
    </div>
    
    <div fxLayout="row wrap" fxLayoutAlign="center" class="w-100 p-2" *ngIf="viewType==='grid'">
        <mat-card class="menu-item" [fxLayout]="(viewType == 'grid') ? 'column' : 'row'"
            [ngClass]="[viewType + '-item', 'column-'+column]" fxFlex.gt-sm="30" fxFlex.sm="30" *ngFor="let item of resultcat | paginate: { itemsPerPage: 10, currentPage: p }">
            <div fxFlex="100" class="p-3">
                <div fxLayout="column" fxLayoutAlign="start stretch" class="h-100">
                    <mat-card-content class="mb-0">
                        <h1 class="title">{{ item.mark_lib}} {{ item.mod_lib }}</h1>
                        <p class="subtitle text-muted">
                            {{ item.created_at | date:"dd MMMM, yyyy 'à' HH:mm" }}
                        </p>
                        <div>
                            <mat-option  class="user-social" style="text-align:center !important;">
                                <mat-slide-toggle color="primary" [(ngModel)]="item.verification" (change)="onChange($event, item.id,item.status) " > {{item.verification==1?"Valide":"Refusé"}}</mat-slide-toggle>
                            </mat-option>                               
                        </div>
                        <div class="mt-2 mb-2"> 
                            <div class="features">
                                <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car" matTooltip="Prix de la location">
                                    <span class="px-1"><mat-icon class="icon-desc">payments</mat-icon> Prix</span>
                                    <span class="dots"></span>
                                    <span class="fw-500">{{item.vehicle_price_location}} {{appService.getCurrency()}}</span>
                                </p>
                                <p  class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">grade</mat-icon> Statut</span>
                                    <br>
                                    <!-- <span class="dots"></span> -->
                                    <span class="fw-500"><mat-form-field appearance="outline" class="p-0 m-0" style="width: 100%">
                                        <mat-label> {{item.status}}</mat-label>
                                        <mat-select  (selectionChange)="onStatusSelectionChange($event  ,item.id)" [disabled]="item.status.id == 1">
                                            <mat-option >---</mat-option>
                                            <mat-option *ngFor="let status of statuses" [value]="status">
                                                {{status.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field></span>
                                </p>
                                <p  class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">supervisor_account</mat-icon> Prioritaire ?                                  </span>
                                    <!-- <span class="px-1">Modèle:</span> -->
                                    <!-- <span class="dots"></span>-->
                                     <br>
                                    <span class="fw-500">
                                        <mat-form-field appearance="outline" class="p-0 m-0" style="width: 100%">
                                            <mat-label> {{item.priority?"Oui":"non"}}</mat-label>
                                            <mat-select  (selectionChange)="changePrioritycar($event,item.id)">
                                                <mat-option [value]="true">Oui</mat-option>
                                                <mat-option [value]="false">Non</mat-option>
                                               
                                            </mat-select>
                                        </mat-form-field>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions class="m-0 p-0">
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="divider mt-1">
                            <button mat-icon-button color="primary" (click)="showCar(item.id )" matTooltip="details">
                                <mat-icon>visibility</mat-icon>
                            </button> 
                            <button mat-icon-button color="warn" (click)="remove(item.id )" matTooltip="Remove">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </mat-card-actions>
                </div>
            </div>
        </mat-card>   
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between" class="w-100 p-2">
        <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20">
            <button  mat-icon-button  color="primary" matTooltip="Rafraichir" (click)="refresh()">
                <span><mat-icon>refresh</mat-icon> Mise à jour</span>
            </button>
        </div>
        
        <div fxFlex="100" fxFlex.gt-sm="80" fxFlex.sm="80" *ngIf="viewType==='grid'">
            <pagination-controls (pageChange)="p = $event" style="text-align: end;"></pagination-controls>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" class="{{viewType==='list' ? 'block' : 'hidden'}}" ></mat-paginator>
    </div>
    
</mat-card>